import { render, staticRenderFns } from "./ManualCancellations.vue?vue&type=template&id=4b84c93e&scoped=true&"
import script from "./ManualCancellations.vue?vue&type=script&lang=js&"
export * from "./ManualCancellations.vue?vue&type=script&lang=js&"
import style0 from "./ManualCancellations.vue?vue&type=style&index=0&id=4b84c93e&scoped=true&lang=css&"
import style1 from "../../assets/css/style-tables-dark.css?vue&type=style&index=1&id=4b84c93e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b84c93e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCardTitle,VDataTable,VIcon,VSkeletonLoader,VSpacer,VTextField})
